import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left",
  "use": "icon-arrow--left-usage",
  "viewBox": "0 0 18 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 10\" id=\"icon-arrow--left\"><path d=\"M5.42 10a.6.6 0 0 0 .375-1.042L2.14 5.604h15.23a.623.623 0 0 0 .63-.63.623.623 0 0 0-.63-.567H2.14l3.656-3.349a.599.599 0 1 0-.81-.879L.191 4.57a.599.599 0 0 0 0 .879l4.792 4.39A.599.599 0 0 0 5.42 10Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol